import { useTranslation } from 'react-i18next';
import { Navigation } from '@cbridge-utils/navigation';
import { RouteSegments } from '../routingClientAdmin.interface';

export const useConfigExternalReportingNavigationItems = () => {
  const { t } = useTranslation();

  const items: Navigation = [
    {
      kind: 'header',
      title: t('text:navigation.config.externalReporting.title'),
    },
    {
      kind: 'page',
      segment: RouteSegments.ExternalReporting.Reports,
      pattern: `${RouteSegments.ExternalReporting.Reports}{/*path}`,
      title: t('text:navigation.config.externalReporting.rules'),
    },
    {
      kind: 'page',
      segment: RouteSegments.ExternalReporting.Servers,
      pattern: `${RouteSegments.ExternalReporting.Servers}{/*path}`,
      title: t('text:navigation.config.externalReporting.servers'),
    },
  ];

  return items;
};
